const tooltipInit = () => {
	document.querySelectorAll('.categories-card__site').forEach((el) => {
		const card = el.closest('.categories-card');
		el.addEventListener('mouseenter', () => {
			const tooltip = card.querySelector(`#${el.dataset.id}`);
			tooltip.classList.add('active');
		});

		el.addEventListener('mouseleave', () => {
			const tooltip = card.querySelector(`#${el.dataset.id}`);
			tooltip.classList.remove('active');
		});
	});
};
export default tooltipInit;
